module.exports = __webpack_public_path__ + "img/thaw-area.7a1317e4.jpg";